import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3596b02e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mxa-nologin-main" }
const _hoisted_2 = { class: "mxa-nologin-main-inputgroup" }
const _hoisted_3 = { class: "mxa-nologin-main-input" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "mxa-nologin-main-input-margin" }
const _hoisted_6 = { class: "mxa-nologin-main-input-margin" }

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import BasePassword from '@/components/common/input/BasePassword.vue'
import BaseButton from '@/components/common/button/BaseButton.vue'
import BaseCheckbox from '@/components/common/input/BaseCheckbox.vue'
import ErrorMessage from '@/components/common/screen/ErrorMessage.vue'
import * as log from '@/model/util/log/Logger'
import { initDom, stateUserEntry, userPasswordEntry, useErrorMsg } from '@/model/components/users/userEntry'
import PasswordDesc from '@/components/common/screen/PasswordDesc.vue'
import NologinTitle from '@/components/main/nologin/NologinTitle.vue'
import RegisterStepbar from '../../components/main/nologin/RegisterStepbar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EntryPassword',
  props: {
  // ユーザー名
  username: {
    type: String,
    default: undefined,
  },
  // ワンタイムパスワード
  onetimepassword: {
    type: String,
    default: undefined,
  },
  // 登録種別
  type: {
    type: String,
    default: undefined,
  },
  // リダイレクト
  redirect: {
    type: String,
    default: undefined,
  },
  // ダウンロードキー
  downloadKey: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props

log.trace('EntryPassword setup start.')

// プロパティ定義


// 状態
const state = stateUserEntry(props)
const store = useStore()
const router = useRouter()
const errorState = useErrorMsg()

log.debug(`EntryPassword props: ${JSON.stringify(props)}, state: ${JSON.stringify(state)}`)
// onMountedの登録
onMounted(async () => {
  log.trace('EntryPassword onMounted start.')
  // F5等でusernameが設定されていない場合はTOP画面に遷移
  await initDom(state, store, router)
  log.trace('EntryPassword onMounted end.')
})
/**
 * 登録ボタンクリック
 */
const onclick = async () => {
  log.trace('EntryPassword onclick start.')
  // api送信の実施
  await userPasswordEntry(state, store, router, errorState)
  log.trace('EntryPassword onclick end.')
}
log.trace('EntryPassword setup end.')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RegisterStepbar, {
      active: 4,
      type: props.type
    }, null, 8, ["type"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(NologinTitle, {
        "is-entry": true,
        type: props.type
      }, null, 8, ["type"]),
      _createVNode(PasswordDesc),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
        novalidate: ""
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("input", {
              type: "text",
              name: "username",
              autocomplete: "username",
              value: _unref(state).username,
              hidden: ""
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(BasePassword, {
                placeholder: _ctx.$t('body.entry.password.placeholder'),
                modelValue: _unref(state).password,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).password) = $event)),
                autocomplete: "new-password",
                "init-focus": true,
                "data-test": "password",
                passwordStatus: !_unref(state).dispPassword
              }, null, 8, ["placeholder", "modelValue", "passwordStatus"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(BasePassword, {
                placeholder: _ctx.$t('body.entry.password2.placeholder'),
                modelValue: _unref(state).passwordConfirm,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).passwordConfirm) = $event)),
                autocomplete: "new-password",
                "data-test": "passwordConfirm",
                passwordStatus: !_unref(state).dispPassword
              }, null, 8, ["placeholder", "modelValue", "passwordStatus"])
            ]),
            _createVNode(BaseCheckbox, {
              class: "mxa-nologin-main-checkbox",
              modelValue: _unref(state).dispPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).dispPassword) = $event)),
              label: _ctx.$t('body.common.passowrd.disp.passowrd'),
              domId: "passupdateCheck",
              inputmode: "none"
            }, null, 8, ["modelValue", "label"])
          ])
        ]),
        _createVNode(ErrorMessage, { error: _unref(errorState) }, null, 8, ["error"]),
        _createVNode(BaseButton, {
          loading: _unref(state).loading,
          isDisabled: _unref(state).loading,
          label: _ctx.$t('body.entry.button.register.title'),
          styles: "mxa-nologin-main-button",
          onButtonClick: onclick
        }, null, 8, ["loading", "isDisabled", "label"])
      ], 32)
    ])
  ], 64))
}
}

})